import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const Education: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden={!title}
      focusable='false'
      width={width}
      height={height}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.448 0.0389937C10.0145 0.232842 8.7541 1.24106 8.25574 2.59267C8.10888 2.99097 8.05126 3.27571 8.00213 3.84597L7.98818 4.00797H5.99808H4.008L4.00392 6.00597C4.00169 7.10488 4.00318 9.35126 4.00723 10.998L4.01465 13.992H2.00731H0V18.996V24L12.006 23.994L24.012 23.988L24.018 18.984L24.0241 13.98L22.0047 13.9862L19.9854 13.9925L19.9928 10.9982C19.9968 9.3514 19.9983 7.10488 19.9961 6.00597L19.992 4.00797H18.0019H16.0118L15.9979 3.84597C15.9494 3.28305 15.8892 2.98641 15.7425 2.5882C15.4656 1.83626 14.9178 1.1446 14.237 0.687474C13.4128 0.134082 12.4317 -0.0940383 11.448 0.0389937ZM11.7866 2.02039C11.3082 2.06066 10.9104 2.26108 10.5446 2.64616C10.2372 2.96978 10.0491 3.38119 10.0169 3.80023L10.0009 4.00797H12H13.9991L13.9831 3.80023C13.9636 3.54587 13.8597 3.22113 13.7232 2.98797C13.6043 2.78464 13.2229 2.39913 13.0262 2.28345C12.6513 2.06289 12.2623 1.98033 11.7866 2.02039ZM6.00617 7.78197C6.01507 9.46039 6.01862 9.58255 6.06691 9.88339C6.22711 10.881 6.60394 11.7893 7.17634 12.5576C8.14277 13.8548 9.52202 14.6844 11.124 14.9321C11.3942 14.9739 11.5658 14.9841 12 14.9841C12.4342 14.9841 12.6058 14.9739 12.876 14.9321C14.478 14.6844 15.8572 13.8548 16.8237 12.5576C17.3961 11.7893 17.7729 10.881 17.9331 9.88339C17.9814 9.58255 17.9849 9.46039 17.9938 7.78197L18.0033 5.99997H12H5.99671L6.00617 7.78197ZM10.488 12V13.008H12H13.512V12V10.992H12H10.488V12ZM0.011784 18.996C0.011784 21.7548 0.014568 22.8869 0.018 21.5119C0.021432 20.1368 0.021432 17.8796 0.018 16.4959C0.014568 15.1121 0.011784 16.2372 0.011784 18.996ZM6 18.1578V22.008H12H18V18.1556V14.3033L17.754 14.5588C16.6004 15.7571 15.0826 16.5721 13.452 16.8688C12.9119 16.9672 12.7454 16.9799 12 16.9799C11.2546 16.9799 11.0881 16.9672 10.548 16.8688C8.93371 16.5751 7.42356 15.7688 6.27 14.5848L6 14.3077V18.1578ZM1.9979 19.002L2.004 21.996H3H3.996L4.0021 19.002L4.00819 16.008H3H1.99181L1.9979 19.002ZM19.9979 19.002L20.004 21.996H21H21.996L22.0021 19.002L22.0082 16.008H21H19.9918L19.9979 19.002Z'
        fill={fill}
      />
    </svg>
  )
}

export default Education
